import React from 'react'
import FillButton from 'Components/Common/components/Button/FillButton';
import OutlineButton from 'Components/Common/components/Button/OutlineButton';
import Label from 'Components/Common/components/Label';
import ModalBody from 'Components/Common/Modal/ModalBody';
import ModalContainer from 'Components/Common/Modal/ModalContainer';
import ModalFooter from 'Components/Common/Modal/ModalFooter';
import ModalHeader from 'Components/Common/Modal/ModalHeader';
import { SuccessIcon } from 'assests/GmsIcons';

type ValidationSuccessModalProps = {
    onClose: () => void
    handleImport: () => void
    importing: boolean
}

const ValidationSuccessModal = ({ handleImport, onClose, importing }: ValidationSuccessModalProps) => {
    return (
        <ModalContainer id="list-validation-success-modal" isOpen={true} setOpen={onClose} width='500px'>
            <ModalHeader>
                <div>
                    <Label
                        message="Validate List"
                        fontSize="0.875"
                        fontWeight="600"
                    />
                </div>
            </ModalHeader>
            <ModalBody>
                <div className="tw-px-4 tw-py-6 tw-flex tw-flex-col tw-items-center">
                    <div className="tw-bg-tone-success-tint tw-rounded-md tw-px-4 tw-mb-8 tw-flex tw-items-center tw-justify-center tw-gap-3">
                        <div className="tw-text-tone-success-ink tw-py-1">
                            <SuccessIcon />
                        </div>
                        <span className="tw-text-tone-success-ink tw-text-lg tw-font-semibold">Zero Errors</span>
                    </div>

                    <FillButton
                        id="list-validation-success-modal-import-btn"
                        onClick={handleImport}
                        className="tw-px-10 tw-py-2"
                        disabled={importing}
                    >
                        {importing ? "Importing..." : "Import File"}
                    </FillButton>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="tw-min-w-full tw-space-x-3 tw-justify-end tw-flex">
                    <OutlineButton id="list-validation-success-modal-cancel-btn" onClick={() => onClose()}>Close</OutlineButton>
                </div>
            </ModalFooter>
        </ModalContainer>
    );
}

export default ValidationSuccessModal